class  TableFootnoteHelper {
  constructor(){
    const subperbScripts = document.querySelectorAll('p.ns-style-footnote span.ns-style-subscript');

    subperbScripts.forEach(scRipt => {
      const parent = scRipt.closest('p.ns-style-footnote');

      if(parent) {
        parent.classList.add('has-subscript');
      }
    });
  }
}

export default TableFootnoteHelper;
